import * as React from "react"

function SvgCheckboxChecked(props) {
  return (
    <svg
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M16 .5H3.5a3 3 0 00-3 3v11a3 3 0 003 3h11a3 3 0 003-3v-4.418"
        stroke="#3B99FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.02 5.528L2.1 8.335l6.995 6.726.09-.087.096.093L21.833 2.998 18.913.191 9.192 9.54 5.02 5.528z"
        fill="#3B99FC"
      />
    </svg>
  )
}

export default SvgCheckboxChecked
